"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useScrollHide(t0) {
  const $ = _c(3);
  const threshold = t0 === undefined ? 10 : t0;
  const [hidden, setHidden] = useState(false);
  let t1;
  let t2;
  if ($[0] !== threshold) {
    t1 = () => {
      let lastScrollY = window.scrollY;
      const handleScroll = () => {
        const current = window.scrollY;
        setHidden(current > lastScrollY && current > threshold);
        lastScrollY = current;
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t2 = [threshold];
    $[0] = threshold;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return hidden;
}